import * as Configuration from '../../../app.constants.js';

AddAccountTrustpilotController.$inject = ['$scope', '$http', 'TopToolbarFactory', '$stateParams', 'company', 'AlertingFactory', 'LoginFactory', '$translate'];
export function AddAccountTrustpilotController($scope, $http, TopToolbarFactory, $stateParams, company, AlertingFactory, LoginFactory, $translate) {
  
  $scope.connectBusinessUnit = connectBusinessUnit;
  init();

  function getBusinessUnits() {
    $scope.isLoading = true;
    const url = Configuration.constants.baseUrl + 'api/1.0/companies/' 
              + company.id + '/trustpilot/' + $scope.requestId + '/business-units/';
    $http.get(url).then(function success(response) {
      if(response.data.error) {
        const redirectUrl = response.data.redirect_url + '?error=' + response.data.error;
        LoginFactory.redirectWithJwtShort(redirectUrl);
      }
      else {
        $scope.businessUnits = response.data.business_units;
        if($scope.businessUnits){
          $scope.selectedBusinessUnitId = $scope.businessUnits.filter(bu => !bu.is_already_connected)[0].id;
        }
        $scope.isLoading = false;
      }
    }, function error(response) {
      AlertingFactory.alertHTTPError(response);
    });
  }

  function connectBusinessUnit(){
    if($scope.selectedBusinessUnitId){
      const url = Configuration.constants.baseUrl + 'api/1.0/companies/' 
              + company.id + '/trustpilot/' + $scope.requestId + '/add-account-done/';
      const selectedBusinessUnit = $scope.businessUnits.filter(bu => bu.id == $scope.selectedBusinessUnitId)[0];
      const data = {
        "id": selectedBusinessUnit.id,
        "name": selectedBusinessUnit.name
      };
      $http.post(url, data).then(function success(response) {
        const redirectUrl = response.data.redirect_url;
        LoginFactory.redirectWithJwtShort(redirectUrl);
      }, function error(response) {
        AlertingFactory.alertHTTPError(response);
      });
    }
  }

  function init() {
    $scope.requestId = $stateParams.requestId;
    const title = $translate.instant('add-account/trustpilot/connect/title');
    TopToolbarFactory.setTitle(title, $scope);
    getBusinessUnits();
  }

}
